export default "__VITE_ASSET__B9atC5C0__"